import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    reportes: [],
    isChangePublicacion: false,
    titleModal: null,
    isPayPlan: null,
    tabsStatus: {},
    componentsActive: {
        cotizar_alert: false,
        cotizar_velocimetro: false,
        cotizar_form: false,
        cotizar_table: false,
        inspeccion_cita: false,
        inspeccion_form: false
    },
    id_reporte: null,
    reporte: {
        kilometraje: 0,
        color_primario: null,
        color_secundario: null,
        ubicacion_id: null,
        ubicacion_name: null,
        modelorel: {
            modelo: null,
            marca: {
                name: null
            },
            lineas: {
                name: null
            },
            avaluo: {
                vr_fasecolda: null
            },
            version: {
                name: null,
                cod_fasecolda: null,

                meta_keys: {
                    clindraje: 0
                }
            }
        },
        clientes: {
            nombre: null,
            apellido: null
        },
        asesor: {
            meta_keys: {
                nombre: null,
                apellido: null
            }
        },
        fichatecnica: {
            kilometraje: 0,
            precio_publicacion: 0,
            datos_vehiculo: {
                placa: 'No tiene'
            },
            inspeccion_legal: {
                estado_propietario_runt: null
            }
        },
        inspeccion_mecanica: {
            onPayPlan: null
        }
    }
};
const mutations = {
    updateField,
    updateReportes: (state, payload) => {
        state.reportes = payload;
    },
    updateActividades: (state, payload) => {
        state.reporte.actividades = payload;
    },
    updateReporte: (state, payload) => {
        state.reporte = payload;
        state.id_reporte = payload._id;
        state.componentsActive = payload.componentsActive;
        state.tabsStatus = payload.fichatecnica.pills_status;
        state.isPayPlan = payload.tipo_inspeccion;
    },
    updateReporteID: (state, payload) => {
        state.id_reporte = payload.id_reporte;
    },
    changeComponents: (state, payload) => {
        state.componentsActive = payload;
    },
    changeTabsStatus: (state, payload) => {
        state.tabsStatus = payload;
    },
    changePublicacion: (state) => {
        state.isChangePublicacion = true;
    },
    changeEstadoPrincipal: (state, payload) =>{
        state.reporte.estado_principal = payload;
    },
    changeEstadoTramite: (state, payload) =>{
        state.reporte.estado_tramite = payload;
    },
    changePayPlan: (state, payload) => {
        state.isPayPlan = payload;
        if(payload == 'pagada'){
            state.componentsActive.inspeccion_cita = true;
        }else{
            state.componentsActive.inspeccion_form = true;
        }
    },
    addAccion: (state, payload) => {
        state.reporte.acciones.push(payload);
    },
    addArchivo: (state, payload) => {
        state.reporte.archivos.push(payload);
    },
    updatePriceCotizacion: (state, payload) => {
        state.cotizacionForm.vr_publicacion = payload.vr_publicado;
        state.cotizacionForm.vr_sugerido = payload.vr_sugerido;
        state.cotizacionForm.vr_retoma = payload.vr_retoma;
        state.cotizacionForm.vr_minimo = payload.vr_minimo;
        state.cotizacionForm.vr_fasecolda = payload.vr_fasecolda;
    },
    updateInspeccionMecanica: (state, payload) => {
        state.reporte.inspeccion_mecanica = payload.reporte.inspeccion_mecanica;
    },
    updateClienteModal: (state, payload) => {
        state.reporte.clientes = payload;
    }
};

const getters = {
    getField,
    fullnameCliente: (state) => {
        var nombreCliente = state.reporte.clientes.nombre;
        var apellidoCliente = state.reporte.clientes.apellido;
        return nombreCliente+' '+apellidoCliente;
    },
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
